import {ThreeBuiltInEquipment} from '../ThreeBuiltInEquipment';
import {Box3, Vector3} from 'three';
import {TRange} from "../../../../../../../common-code/types/math/TRange";

export class ThreeBuiltinMicrowaveEquipment extends ThreeBuiltInEquipment {

    protected initPosition(): Vector3 {
        let cover: Box3;
        let initPosition: Vector3;
        let corpusPosition: Vector3;
        let positionRangeInUnit: TRange | undefined;

        cover = this.unit.getCorpusCoverBox();
        corpusPosition = this.unit.getCorpusPosition();
        initPosition = new Vector3();
        positionRangeInUnit = this.unit.getMicrowavePositionRange();
        if (positionRangeInUnit) {
            initPosition.y = positionRangeInUnit.min + this.getHeight() / 2;
            initPosition.z = corpusPosition.z + cover.max.z - this.getDepth() / 2;
            return initPosition;
        }
        initPosition.y = cover.min.y + this.getHeight() / 2;
        initPosition.z = corpusPosition.z + cover.max.z - this.getDepth() / 2;

        return initPosition;
    }
}